import { Link } from 'react-router-dom';

const tiles = [
  {
    title: 'About Us',
    to: '/about-us',
    icon: 'garage',
    image:
      'https://images.unsplash.com/photo-1607860108855-64acf2078ed9?auto=format&fit=crop&w=1600&q=80',
  },
  {
    title: 'Sell Your Car',
    to: '/sell-your-car',
    icon: 'tag',
    image:
      'https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=1600&q=80',
  },
  {
    title: 'Showroom',
    to: '/search',
    icon: 'car',
    image:
      'https://images.unsplash.com/photo-1542282088-fe8426682b8f?auto=format&fit=crop&w=1600&q=80',
  },
];

function TileIcon({ icon }) {
  if (icon === 'garage') {
    return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <path d="M3 10.5 12 4l9 6.5" />
        <path d="M5 10.5V20h14v-9.5" />
        <path d="M9 20v-5h6v5" />
      </svg>
    );
  }

  if (icon === 'tag') {
    return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <path d="M3.5 12 12 3.5h6.5v6.5L10 18.5a2.1 2.1 0 0 1-3 0L3.5 15a2.1 2.1 0 0 1 0-3Z" />
        <circle cx="15.5" cy="8.5" r="1.2" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path d="M4 13.5h16" />
      <path d="M6.2 13.5 8 9.3h8l1.8 4.2" />
      <path d="M6.5 17.8a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6Z" />
      <path d="M17.5 17.8a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6Z" />
    </svg>
  );
}

function HomeFeatureLinks() {
  return (
    <section className="home-feature-links" aria-label="Explore more">
      <div className="home-feature-links-grid">
        {tiles.map((tile) => (
          <Link
            key={tile.title}
            to={tile.to}
            className="home-feature-tile"
            style={{ '--tile-image': `url(${tile.image})` }}
            aria-label={`Go to ${tile.title}`}
          >
            <span className="home-feature-icon" aria-hidden="true">
              <TileIcon icon={tile.icon} />
            </span>
            <h3>{tile.title}</h3>
          </Link>
        ))}
      </div>
    </section>
  );
}

export default HomeFeatureLinks;